import Vue from 'vue'
import { TablePage } from '@oit/element-ui-extend'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/components/element-ui'

import 'windi.css'
import { post } from './api'

router.beforeEach((to, from, next) => {
  document.title = '万成管理系统'
  if (to.name) {
    next()
  }
  else {
    return
  }
  if (to.meta.requiresAuth) {
    if (localStorage.getItem('userId')) {
      next()
    }
    else {
      Message('暂无权限，请登录后再试')
      next({
        path: '/login',
      })
    }
  }
  next()
})
/**
 * 全局权限判断方法
 */
function hasPermission(moduleName) {
  // 1. 超级管理员 (roleId 1 或 2) 拥有所有权限
  const roleId = localStorage.getItem('roleId')
  if (roleId === '1' || roleId === '2') {
    return true
  }

  // 2. 获取当前用户的权限列表 (从 localStorage 读取)
  const menuListStr = localStorage.getItem('menuList')
  if (!menuListStr) {
    return false
  }

  let menuList = []
  try {
    menuList = JSON.parse(menuListStr)
  }
  catch (e) {
    console.error('解析权限列表失败', e)
    return false
  }

  // 3. 判断模块名是否在列表中
  return Array.isArray(menuList) && menuList.includes(moduleName)
}

Vue.prototype.$hasPerm = hasPermission

window.hasPerm = hasPermission

Vue.use(TablePage, {
  setFields() {
    if (sessionStorage.headTitString) {
      return JSON.parse(sessionStorage.headTitString)
    }
  },
})

const [routerPush, routerReplace] = [VueRouter.prototype.push, VueRouter.prototype.replace]
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error)
}

Vue.prototype.$post = post
Vue.prototype.console = console
Vue.prototype.debug = console.log

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
